import { Component, OnInit } from '@angular/core';
import {API} from "../../../../shared/apis/api";
import {CommonConstants} from "../../../../shared/constants/common-constants.enum";
import {ActionBarType} from "../../../../shared/constants/action-bar-type.enum";
import {UrlType} from "../../../../shared/constants/url-type.enum";
import {BodyContentModel} from "../../../../shared/model/body-content-model";
import {ActivatedRoute, Router} from "@angular/router";
import {StationAddComponent} from "../station-add/station-add.component";
import * as _ from 'lodash';
import {ActionBarConfig} from "../../../../shared/model/action-bar-config";
import {HeaderInfo} from "../../../../shared/model/header-info";
import {Cooperative} from "../../../../shared/model/cooperative";
import {take} from "rxjs/operators";
import {HttpCustomService} from "../../../../service/http-custom.service";

@Component({
  selector: 'omni-station-list',
  templateUrl: './station-list.component.html',
  styleUrls: ['./station-list.component.scss']
})
export class StationListComponent implements OnInit {
  bodyContent: BodyContentModel;
  cooperativeNo: string;
  actionBarConfig: ActionBarConfig;
  refresh = false;
  headerInfo: HeaderInfo;
  cooperative: Cooperative;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpCustomService
  ) { }

  ngOnInit(): void {
    this.cooperativeNo = this.route.snapshot.paramMap.get('cooperativeNo');
    this.initActionBarConfig();
    this.getCooperativeInfo();
  }

  private getCooperativeInfo() {
    const url = {
      path: API.COOPERATIVE_DETAIL,
      bind: {
        cooperativeNo: {
          name: 'cooperativeNo',
          placeholder: ':cooperativeNo'
        }
      },
      values: {cooperativeNo: this.cooperativeNo}
    };
    this.http.get(url).pipe(take(1)).subscribe(res => {
      if (res) {
        this.cooperative = res;
        this.initHeaderInfo();
        this.buildBodyContent();
        this.refresh = !this.refresh;
      }
    }, error => {
      this.router.navigate(['/meter-cooperative/home']).finally();
    })
  }

  refreshAll(): void {
    this.getCooperativeInfo();
    this.refresh = !this.refresh;
  }

  initHeaderInfo(): void {
    this.headerInfo = new HeaderInfo();
    this.headerInfo.statusCode = this.cooperative.statusCode;
    this.headerInfo.title = 'Thông tin HTX';
    this.headerInfo.name = `Mã HTX: ${this.cooperative.cooperativeCode} --- Tên HTX: ${this.cooperative.cooperativeName} --- Ngày kết thúc: ${this.cooperative.effectiveEndDate}`;
  }


  private initActionBarConfig(): void {
    this.actionBarConfig = {
      buttonBarConfigs: [
        {actionBarType: ActionBarType.CLOSE, customAction: true}
      ]
    };
  }

  buildBodyContent() {
    const params = {};
    if (_.isNil(this.cooperativeNo)) {
      this.cooperativeNo = localStorage.getItem(CommonConstants.USER_COOPERATIVE_NO);
    }
    if (!_.isNil(this.cooperativeNo) && this.cooperativeNo !== 'null') {
      _.assign(params, {'cooperative-no': this.cooperativeNo});
    }
    const urlTypes = {
      [UrlType.DELETE]: {path: API.STATION_DELETE}
    };
    this.bodyContent = {
      header: {
        title: 'Danh sách Trạm'
      },
      searchArea: {
        box: true,
        placeholder: 'Tìm kiếm Trạm'
      },
      tableConfig: {
        rowId: 'stationNo',
        columnNameRouter: 'stationNo',
        enableLink: true,
        enableCheckbox: true,
        columnData: this.buildStationColumns(),
        isCustomSorting: true,
        editUrl: `/meter-cooperative/cooperative/${this.cooperativeNo}/station/:routerId/customer`,
        urlStateParam: {path: API.STATION},
        customParams: params
      },
      subActionBars: {
        addNewForm: StationAddComponent,
        initState: {
          cooperative: this.cooperative
        },
        urlType: urlTypes,
        buttonBarConfigs: [
          {actionBarType: ActionBarType.NEW, customLabel: CommonConstants.ADD_NEW_STATION_LABEL},
          {actionBarType: ActionBarType.DELETE, isRefreshNav: true},
        ],
        id: 'station-list',
        deleteMessageNoRef: true
      }
    }
  }

  buildStationColumns() {
    return [
      {
        name: 'Tên Trạm',
        data: 'stationName',
        customSortingField: 'stationName',
        type: 'link',
      },
      {
        name: 'Mã Trạm',
        data: 'stationCode',
        customSortingField: 'stationCode',
      },
      {
        type: 'edit',
        orderable: false,
        editComponent: StationAddComponent,
        initStateObject: 'station'
      }
    ];
  }

  close() {
    this.router.navigateByUrl('meter-cooperative/cooperative').finally();
  }
}

